<template>
  <div>
    <v-row align="center">
      <v-col md="9" cols="12" class="py-0">
        <vue-carousel
          :key="`contact-person-carousel-${contactPersons.length}`"
          :options="{
            perPage: {
              0: 2,
              800: 3, // 2 items for viewport wider than 800px
              1240: 3 // 3 items for viewport wider than 1240px
            }
          }"
          from="contact-person"
          :show-button="contactPersons.length > 3"
        >
          <template slot="buttonsColumn">
            <div class="caption font-weight-bold grey--text">
              Create Communication Logs from Contact Persons Below:
            </div>
          </template>
          <template
            v-if="!contactPersonLoading && contactPersons.length"
            slot="carousel"
          >
            <v-responsive
              v-for="(contactPerson, i) in contactPersons"
              :key="`contactPerson-${i}`"
              class="ma-1 white flex-grow-0 pointer pl-0"
              :class="{
                'selected-contact-person':
                  selectedContactPerson === contactPerson
              }"
              @click="
                selectedContactPerson === contactPerson
                  ? (selectedContactPerson = undefined)
                  : (selectedContactPerson = contactPerson)
              "
            >
              <v-menu open-on-hover offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-inline-flex" v-bind="attrs" v-on="on">
                    <v-avatar color="indigo" size="36" class="mt-2 mr-1">
                      <img
                        :src="
                          contactPerson.image ||
                            require(`@/static/images/info/user-default.png`)
                        "
                        alt="CRE avatar"
                      />
                    </v-avatar>
                    <div class="mr-2 mb-2 mt-1">
                      <div class="body-2 blue--text">
                        {{ contactPerson.name }}
                      </div>
                      <div class="caption grey--text">
                        {{
                          contactPerson.designation
                            ? contactPerson.designation.name
                            : "N/A"
                        }}
                      </div>
                    </div>
                  </div>
                </template>

                <v-list>
                  <v-list-item
                    @click="
                      $emit('triggerLogForm', {
                        formType: 'Communication',
                        contactPerson,
                        contactPersonList: contactPersons
                      })
                    "
                  >
                    <v-list-item-title>
                      <v-icon v-text="$getIcon('mdiPhone')"></v-icon>
                      <span class="body-2 ml-2">Create Communication Log</span>
                    </v-list-item-title>
                  </v-list-item>
                  <!-- <v-divider></v-divider> -->
                  <!-- <v-list-item>
                    <v-list-item-title>
                      <v-icon
                        v-text="$getIcon('mdiInformationOutline')"
                      ></v-icon>
                      <span class="body-2 ml-2 text--secondary">
                        Create Process Log
                      </span>
                    </v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </v-responsive>
          </template>
          <template v-if="contactPersonLoading" slot="carousel">
            <v-responsive>
              <v-row
                ><v-col
                  v-for="i in 2"
                  cols="6"
                  :key="`contactPersonSkeleton-${i}`"
                >
                  <v-skeleton-loader
                    type="list-item-avatar-two-line"
                    width="300"
                    height="60"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-responsive>
          </template>
          <template
            v-if="!contactPersonLoading && contactPersons.length == 0"
            slot="carousel"
          >
            <v-responsive class="align-center py-3">
              No contact person. Start Adding
            </v-responsive>
          </template>
        </vue-carousel>
      </v-col>
      <v-col cols="12" md="3" class="pr-3 ">
        <v-btn @click="drawer = true" outlined color="blue">{{
          selectedContactPerson ? "Update Contact" : "Add Contact"
        }}</v-btn>
      </v-col>
    </v-row>
    <div>
      <v-navigation-drawer
        width="900"
        v-model="drawer"
        right
        temporary
        fixed
        clipped
      >
        <template v-slot:prepend>
          <v-card tile>
            <vue-card-title
              :title="contactPersonFormTitle"
              dark
              :subtitle="'Fill up the following form to action on client data.'"
              :icon="$getIcon('mdiFileDocumentEdit')"
              closable
              @close="drawer = false"
            >
            </vue-card-title>
            <v-divider></v-divider>
          </v-card>
        </template>
        <contact-person-form
          v-if="drawer"
          :client="client"
          :action-data="
            selectedContactPerson ? selectedContactPerson : undefined
          "
          @close="drawer = false"
          @contactPersonFormResponse="formSuccess()"
        >
        </contact-person-form>
      </v-navigation-drawer>
    </div>
  </div>
</template>
<script>
import ContactPersonForm from "@/components/crm/client/forms/ContactPersonForm";
import { mdiPlus, mdiUpdate } from "@mdi/js";
import VueCarousel from "@/components/common/layout_utils/VueCarousel";

export default {
  icons: {
    mdiPlus,
    mdiUpdate
  },
  props: {
    client: {
      type: Object,
      default: null
    },
    contactPerson: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      carouselKey: 1,
      drawer: false,
      selectedContactPerson: undefined,
      contactPersons: [],
      contactPersonLoading: false,
      contactPersonScrollLeftValue: 0
    };
  },
  components: {
    ContactPersonForm,
    VueCarousel
  },
  mounted() {
    this.client && this.getContactPersons();
    this.contactPersonLoading = true;
  },
  watch: {
    selectedContactPerson: function(newVal) {
      this.$emit("update:contactPerson", newVal);
    },
    client: function() {
      this.getContactPersons();
      this.selectedContactPerson = undefined;
    }
  },
  methods: {
    scroll(pixel) {
      this.$refs.contactPersonsScrollableEl.scrollLeft += pixel;
      this.contactPersonScrollLeftValue = this.$refs.contactPersonsScrollableEl.scrollLeft;
    },
    getContactPersons() {
      this.$axios
        .get(
          `/api/v1/crm/client-contact-person/choices/?client__slug=${this.client.slug}`
        )
        .then(({ data }) => {
          this.contactPersons = data;
          this.contactPersonLoading = false;
        });
    },
    formSuccess() {
      this.getContactPersons();
      this.selectedContactPerson = undefined;
    }
  },
  computed: {
    contactPersonFormTitle() {
      let action = this.selectedContactPerson ? "Update" : "Create";
      return `${action} Contact Person`;
    }
  }
};
</script>
<style scoped>
.selected-contact-person {
  box-shadow: 0 10px 6px -6px #777;
}
</style>
